import { render, staticRenderFns } from "./ExternalLineType.vue?vue&type=template&id=54b48d0f&lang=pug&"
import script from "./ExternalLineType.vue?vue&type=script&lang=js&"
export * from "./ExternalLineType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports